export const FETCH_DIRECTORY_PRODUCTS = "FETCH_DIRECTORY_PRODUCTS";
export const FETCHED_DIRECTORY_PRODUCTS = "FETCHED_DIRECTORY_PRODUCTS";
export const SEARCH_DIRECTORY_PRODUCTS = "SEARCH_DIRECTORY_PRODUCTS";
export const SELECT_DIRECTORY_PRODUCT = "SELECT_DIRECTORY_PRODUCT";
export const SEARCH_DIRECTORY_PRODUCTS_ANYWARE =
  "SEARCH_DIRECTORY_PRODUCTS_ANYWARE";
export const SEARCH_DIRECTORY_PRODUCTS_START_WITH =
  "SEARCH_DIRECTORY_PRODUCTS_START_WITH";
export const ANYWHERE_PARAM_PRODUCT = "ANYWHERE_PARAM_PRODUCT";
export const START_WITH_PARAM = "START_WITH_PARAM";
export const FETCH_DETAILS_FOR_SELECTED_PRODUCT =
  "FETCH_DETAILS_FOR_SELECTED_PRODUCT";
export const FETCHED_DETAILS_FOR_SELECTED_PRODUCT =
  "FETCHED_DETAILS_FOR_SELECTED_PRODUCT";
export const SELECT_ALL_PRODUCTS = "SELECT_ALL_PRODUCTS"
export const CLEAR_ALL_SELECTION_PRODUCTS = "CLEAR_ALL_SELECTION_PRODUCTS"

export const SELECT_STATE_ALL_PRODUCTS = "all"
export const SELECT_STATE_PART_PRODUCTS = "part"

export function fetchIfNededDirectoryProducts(first, search) {

  return (dispatch, getState) => {

    if (first && !search && getState().directoryProductsReducer.isResultFetched) {
      return;
    }

    dispatch(
      fetchDirectoryProducts(
        first,
        getState().internationalizationReducer.activeLangCode
      )
    );

    let inputBody = {};
    inputBody.paging = {
      current_page: getState().directoryProductsReducer.currentPage,
      items_per_page: 20,
      lang: "en"
    };

    inputBody.search = {
      anyware: getState().directoryProductsReducer.searchAnywhereParam,
      startingWith: getState().directoryProductsReducer.startWithParam
    };

    return fetch("/ndap/directory/product/search", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: getState().directoryProductsReducer.activeLangCodeOfPages
      },
      body: JSON.stringify(inputBody)
    })
      .then(response => {
        if (!response.ok) throw Error(response.statusText);
        return response;
      })
      .then(response => response.json())
      .then(responseJson => {
        // responseJson.unshift(["Activity", "Indicators", "Regions", "Value", "Years"]);
        dispatch(fetchedDirectoryProducts(responseJson));
      })
      .catch(error => {
        console.error(error);
      });
  };
}

export function fetchDirectoryProducts(first, activeLangCode) {
  return { type: FETCH_DIRECTORY_PRODUCTS, first, activeLangCode };
}

export function fetchedDirectoryProducts(directoryProducts) {
  return { type: FETCHED_DIRECTORY_PRODUCTS, directoryProducts };
}

export function selectDirectoryProduct(directoryProduct) {
  return { type: SELECT_DIRECTORY_PRODUCT, directoryProduct };
}

export function searchAnywhere(searchAnywhereParam) {
  return { type: ANYWHERE_PARAM_PRODUCT, searchAnywhereParam };
}

export function startWith(startWithParam) {
  return { type: START_WITH_PARAM, startWithParam };
}

export function checkUncheckAllProducts() {
  return { type: SELECT_ALL_PRODUCTS };
}

export function clearAllSelection() {
  return { type: CLEAR_ALL_SELECTION_PRODUCTS }
}



// WEBPACK FOOTER //
// ./src/features/modules/directory-of-manufactory/directory-products/DirectoryProductsActions.js